import React, { useState, useEffect, createRef } from 'react';
import { Row, Col, Button } from 'reactstrap';
import { MapContainer, TileLayer, Marker } from 'react-leaflet';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileAlt, faFilter, faSearch, faStreetView } from '@fortawesome/free-solid-svg-icons';
import MarkerClusterGroup from 'react-leaflet-markercluster';
import moment from 'moment/moment';

//Components
import MainCard from '../../components/MainCard/MainCard';
import Loading from '../../components/Loading/Loading';
import ModalCustomized from '../../components/Modal/Modal';
import FichaGeradorContainer from '../../views/Cadastros/Geradores/components/FichaGeradorContainer';
import TextField from '../../components/TextField/TextField';

//Assets
import {
    iconeAmarelo,
    iconeAzul,
    iconeNormal,
    iconeVermelho,
    iconeAmareloAtivo,
    iconeAzulAtivo,
    iconeVermelhoAtivo,
    iconeNormalAtivo
} from '../../assets/Icons/Icons';

//Api
import mapasService_api from '../../api/mapasService_api';
import gerador_api from '../../api/gerador_api';

//Helpers
import { showMessage } from '../../helpers/message';
import { getSessionCookie } from '../../helpers/cookies';
import mascaras from '../../helpers/mascaras';

export default function MapaDeVistorias() {
    //Dados do usuario logado
    const usuario = getSessionCookie();

    //Controle de visibilidade do modal na tela
    const [openModal, setOpenModal] = useState(false);
    const toggleModal = () => setOpenModal(!openModal);

    //Estado de controle do ponto selecionado
    const [pointSelected, setPointSelected] = useState(false);

    //Estado de controle do loading na tela
    const [loading, setLoading] = useState(false);

    //Estado de controle do mapa
    const [map, setMap] = useState(null);

    //Estado de controle da visão de sateleti
    const [viewSatelite, setViewSatelite] = useState(() => false);

    //Função de troca do estado de visão de sateleti
    const toggleViewSatelite = () => setViewSatelite(() => !viewSatelite);

    //Estado que guarda os pontos das coletas programadas
    const [fiscalizacoes, setFiscalizacoes] = useState([]);

    //Estado de controle do ponto central do mapa
    const [location, setLocation] = useState([-23.2198396, -45.8915658]);

    //Estado de controle dos dados do gerador
    const [gerador, setGerador] = useState(null);

    const [filtros, setFiltros] = useState({
        statusGerador: "",
        cnpj: "",
        endereco: ""
    });

    const [openFiltros, setOpenFiltros] = useState(false);

    //Função de troca do estado de visualização dos filtros
    const toggleFiltros = () => {
        setOpenFiltros(!openFiltros);
    };

    //OnChange para os campos de filtros de datas
    const onChangeSelected = (e, select) => {
        const { name } = select;
        setFiltros({
            ...filtros,
            [name]: e ? e.value : null
        })
    }

    const onChange = (e) => {
        const { name, value } = e.target;
        setFiltros({ 
            ...filtros, 
            [name]: value 
        })
    }

    //Status possiveis para as coletas efetuadas
    const status = [
        { value: "Aguardando Vistoria", color: "Warning" },
        { value: "Não Classificado", color: "Warning" },
        { value: "Pequeno gerador", color: "Success" },
        { value: "Vistoria em Andamento", color: "Danger" },
        { value: "Grande Gerador", color: "Primary" },
    ];

    //Status possiveis para geradore
    const optionsStatusGerador = [
        { label: "Pequeno Gerador", value: "Pequeno Gerador" },
        { label: "Grande Gerador", value: "Grande Gerador" },
        { label: "Vistoria em Andamento", value: "Vistoria em Andamento" },
        { label: "Aguardando Vistoria", value: "Aguardando Vistoria" },
    ];

    function loadMapaFiscalizacao() {
        setLoading(true);
        mapasService_api.MapaFiscalizacao(filtros).then(response => {
            response.data = response.data.map(value => {
                value.divRef = createRef(null);
                value.markerRef = createRef(null);
                value.latitude = value.latitude.replace(",", ".");
                value.longitude = value.longitude.replace(",", ".");
                return value;
            });
            if (response?.data?.length > 0)
                setLocation([parseFloat(response.data[0].latitude), parseFloat(response.data[0].longitude)]);
            setFiscalizacoes(response.data);
        }).catch(e => showMessage("Aviso!", e.message, "error", null))
            .finally(f => setLoading(false));
    }

    useEffect(() => {
        loadMapaFiscalizacao();
    }, []);

    function handleFichaGerador() {
        if (pointSelected != null) {
            setLoading(true);
            gerador_api.GetItem(pointSelected?.gerador_Id ? pointSelected?.gerador_Id : 0)
                .then(response => {
                    if (response.data.tbPrefeituras_id) {
                        response.data.tbPrefeituras_id = response.data.tbPrefeituras_id.toString();
                    }
                    if (response.data.tbSetores_Id) {
                        response.data.tbSetores_Id = response.data.tbSetores_Id.toString();
                    }
                    if (response.data.tbSegmentos_Id) {
                        response.data.tbSegmentos_Id = response.data.tbSegmentos_Id.toString();
                    }
                    if (response.data.dataValidade) {
                        response.data.dataValidade = moment(response.data.dataValidade).format("YYYY-MM-DD")
                    }

                    response.data.localidades = response.data.localidades.map(localidade => {
                        if (localidade.localidadePadrao) {
                            localidade.principal = "Sim";
                        } else {
                            localidade.principal = "Não";
                        }
                        localidade.contratos = localidade.contratos.map(contrato => {
                            Object.keys(contrato).map(key => {
                                if (!contrato[key] === null) {
                                    contrato[key] = "";
                                }

                            });
                            contrato.quantidadeContratada = contrato.quantidadeContratada ? contrato.quantidadeContratada.toString().replace(".", ",") : "";
                            return contrato;
                        });

                        return localidade;
                    })
                    setGerador(response.data);

                })
                .catch(e => showMessage("Aviso", e.message, "error", null))
                .finally(f => setLoading(false));
        }
    }

    if (gerador) {
        return <MainCard
            btnVoltar={() => setGerador(null)}
        >
            <FichaGeradorContainer
                gerador={gerador}
                modulo={usuario.acesso.modulo}
                integracaoCadastros={false}
                visualizarFicha={true}
            />
        </MainCard>
    }

    return (
        <MainCard noCard title={"Mapa de Vistorias"}>
            {loading && <Loading />}
            {loading ?
                <></>
                :
                <>
                    <ModalCustomized
                        title={"Informações do ponto selecionado"}
                        isOpen={openModal}
                        toggle={toggleModal}
                        btnClose={toggleModal}
                    >
                        <div >
                            {
                                status.map((valueStatus, key) => {
                                    if (valueStatus.value === pointSelected.status) {
                                        return (<p key={key} className={`status p-2 status${valueStatus.color} rounded-3`}> <span className="fw-bold" >Status: </span> {valueStatus.value}</p>)
                                    }
                                })
                            }
                            <div className="d-flex align-items-center justify-content-between text-secondary">
                                <p className='m-1'> <span className="fw-bold">Identificacao: </span> {pointSelected.identificacao}</p>
                            </div>
                            <p className='m-1 text-secondary'> <span className="fw-bold">Endereco: </span> {pointSelected.endereco}</p>
                            <div className="mt-3 d-flex align-items-center justify-content-center w-100">
                                <Button color='primary' onClick={handleFichaGerador}>
                                    <FontAwesomeIcon size='1x' icon={faFileAlt} className='mr-2' /> Visualizar Ficha do Gerador
                                </Button>
                            </div>
                        </div>
                    </ModalCustomized >
                    <div className={`d-flex align-items-center justify-content-end mb-${openFiltros ? "2" : "3"}`}>
                        <Button color='primary' onClick={toggleFiltros}><FontAwesomeIcon icon={faFilter} /> Filtros</Button>
                    </div>
                    <div className={`filtros ${!openFiltros ? "close" : ""}`}>
                        <Row className='d-flex align-items-center justify-content-center'>
                            <Col md="12" lg="3" className='px-0'>
                                <TextField
                                    label={"* Status Gerador"}
                                    options={optionsStatusGerador}
                                    type="select"
                                    value={optionsStatusGerador.filter(x => x.value == filtros.statusGerador)}
                                    name={"statusGerador"}
                                    onChange={onChangeSelected}
                                    searchable
                                />
                            </Col>
                            <Col md="12" lg="3" className='mx-0'>
                                <TextField
                                    label={"Gerador (CNPJ)"}
                                    name={"cnpj"}
                                    type={"text"}
                                    onChange={onChange}
                                    value={filtros.cnpj}
                                    mask={mascaras.cnpjMask}
                                    maxLength={18}
                                    onBlur={() => setFiltros({
                                        ...filtros,
                                        ["cnpj"]: mascaras.cnpjMask(filtros.cnpj, true)
                                    })}
                                />
                            </Col>
                            <Col md="12" lg="4" className='mx-0'>
                                <TextField
                                    label={"Logradouro e Número (separados por vírgula)"}
                                    name="endereco"
                                    value={filtros.endereco}
                                    onChange={onChange}
                                />
                            </Col>
                            <Col md="12" lg='2'>
                                <Button className='w-100' color='info text-light mt-3' onClick={() => loadMapaFiscalizacao()}><FontAwesomeIcon icon={faSearch} /> Filtrar</Button>
                            </Col>
                        </Row>
                    </div>
                    <Row className='bg-white rounded-3 p-2  shadow'>
                        <Col md="12" lg="3" className='d-flex flex-column align-items-center justify-content-center'>
                            <img src={require("../../assets/img/iconeNormal.png")} width={30} />
                            <span className="fw-bold text-secondary">Pequeno Gerador</span>
                        </Col>
                        <Col md="12" lg="3" className='d-flex flex-column align-items-center justify-content-center'>
                            <img src={require("../../assets/img/iconeAzul.png")} width={30} />
                            <span className="fw-bold text-secondary">Grande Gerador</span>
                        </Col>
                        <Col md="12" lg="3" className='d-flex flex-column align-items-center justify-content-center'>
                            <img src={require("../../assets/img/iconeVermelho.png")} width={30} />
                            <span className="fw-bold text-secondary">Vistoria em Andamento</span>
                        </Col>
                        <Col md="12" lg="3" className='d-flex flex-column align-items-center justify-content-center'>
                            <img src={require("../../assets/img/iconeAmarelo.png")} width={30} />
                            <span className="fw-bold text-secondary">Aguardando Vistoria</span>
                        </Col>
                    </Row>
                    <Row style={{ height: "65vh", backgroundColor: "#eee" }} className="mt-3 rounded-3 overflow-hidden shadow" >

                        <Col md="12" lg="12" className=' m-0 p-0'>
                            <MapContainer
                                center={fiscalizacoes.length === 0 ? location : [parseFloat(fiscalizacoes[0].latitude), parseFloat(fiscalizacoes[0].longitude)]}
                                zoom={13}
                                ref={map}
                                whenCreated={mapRef => setMap(mapRef)}
                                style={{ height: "100%", width: "100%", backgroundColor: "#333" }}
                            >
                                <Button color='light border' className='buttonSatelite' onClick={toggleViewSatelite}><FontAwesomeIcon size='1x' icon={faStreetView} /></Button>
                                <TileLayer
                                    url="https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png"
                                    attribution='© <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, © <a href="https://carto.com/attribution">CARTO</a>'
                                />
                                {
                                    viewSatelite
                                    &&
                                    <TileLayer
                                        url='https://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}'
                                        maxZoom={20}
                                        subdomains={['mt1', 'mt2', 'mt3']}
                                    />

                                }



                                <MarkerClusterGroup>
                                    {fiscalizacoes.map((value, index) => {
                                        let icone;
                                        let iconeAtivo;
                                        if (value.status == "Pequeno Gerador") {
                                            iconeAtivo = iconeNormalAtivo;
                                            icone = iconeNormal;
                                        } else if (value.status == "Vistoria em Andamento") {
                                            iconeAtivo = iconeVermelhoAtivo;
                                            icone = iconeVermelho;
                                        } else if (value.status == "Aguardando Vistoria" || value.status == "Não Classificado") {
                                            iconeAtivo = iconeAmareloAtivo;
                                            icone = iconeAmarelo;
                                        } else {
                                            iconeAtivo = iconeAzulAtivo;
                                            icone = iconeAzul;
                                        }
                                        return (

                                            <Marker key={index} icon={pointSelected.id == value.id ? iconeAtivo : icone} position={[parseFloat(value.latitude), parseFloat(value.longitude)]}
                                                eventHandlers={{
                                                    click: (e) => {
                                                        setLocation(e.latlng);
                                                        if (map != null) {
                                                            map.flyTo(e.latlng);
                                                        }
                                                        setPointSelected(value);
                                                        toggleModal();
                                                    },
                                                }}
                                                ref={value.markerRef}
                                            >
                                            </Marker>
                                        )
                                    })}
                                </MarkerClusterGroup>
                            </MapContainer>
                        </Col>
                    </Row>
                </>
            }
        </MainCard>
    )
}